<template>
  <div id="nav" :class="{ 'nav-login-page': isLoginPage }">
    <div class="uf">
      <div class="logo uf-f1">
        <router-link to="/"><img src="../assets/logo.png" /></router-link>
      </div>
      <div class="menu">
        <ul>
          <li :class="$store.state.menuIndex == 0 ? 'active' : false">
            <router-link to="/">{{$t('nav.home')}}</router-link>
          </li>
          <li :class="$store.state.menuIndex == 1 ? 'active' : false">
            <router-link to="/dealer">{{$t('nav.dealer')}}</router-link>
          </li>
          <li :class="($store.state.menuIndex == 2&&$route.name!='Login'&&$route.name!='Content') ? 'active' : false">
            <router-link to="/help">{{$t('nav.help')}}</router-link>
          </li>
          <li :class="$store.state.menuIndex == 3 ? 'active' : false">
            <router-link to="/subscription">{{$t('nav.subscription')}}</router-link>
          </li>
          <!-- <li :class="$store.state.menuIndex==4?'user active':'user'"><a href="#"><img src="../assets/icon_user.png"></a></li> -->
          <li :class="$store.state.menuIndex == 4 ? 'user' : 'user'">
            <!-- <div class="user-container">
              <a href="javascript:;" @click="toggleLoginCard">
                <img src="../assets/icon_user.png" />
              </a>
              <LoginCard :visible="showLoginCard" @close="closeLoginCard" />
              
            </div> -->
            <el-dropdown class="user_dropdown" @command="handleCommand">
              <a href="javascript:;"
                ><img
                  v-if="userInfo && userInfo.avatar"
                  :src="userInfo.avatar" /><img
                  v-else
                  src="../assets/icon_user.png"
              /></a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="!getToken()" command="__login__"
                  >
                  <button class="login-btn">{{$t('userMenu.login')}}</button>
                  </el-dropdown-item
                >
                <el-dropdown-item command="/user"
                  ><i class="u_user"></i>{{$t('userMenu.profile')}}</el-dropdown-item
                >
                <el-dropdown-item command="/subscription"
                  ><i class="u_sub"></i>{{$t('userMenu.subscription')}}</el-dropdown-item
                >
                <el-dropdown-item command="/user/promotion"
                  ><i class="u_tg"></i>{{$t('userMenu.promotion')}}</el-dropdown-item
                >
                <el-dropdown-item command="/help"
                  ><i class="u_qs"></i>{{$t('userMenu.help')}}</el-dropdown-item
                >
                <el-dropdown-item command="/user/order"
                  ><i class="u_od"></i>{{$t('userMenu.order')}}</el-dropdown-item
                >
                <el-dropdown-item command="/wallet"
                  ><i class="u_wallet"></i>{{$t('userMenu.wallet')}}</el-dropdown-item
                >
                <el-dropdown-item command="/user/coupons"
                  ><i class="u_coupon"></i>{{$t('userMenu.coupons')}}</el-dropdown-item
                >
                <el-dropdown-item
                  ><i class="u_lang"></i>{{$t('userMenu.changeLang')}}
                  <div class="switch_lang">
                    <ChangeLanguage/>
                  </div>
                  </el-dropdown-item
                >
                <el-dropdown-item v-if="getToken()"
                  ><a class="logout" @click="logout"
                    >{{$t('userMenu.logout')}}</a
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </div>

    <!-- 登录弹窗 - 已注释 -->
    <!-- <el-dialog
      title="登录"
      :visible.sync="$store.state.showLogin"
      :center="true"
      @close="$store.state.showLogin = false"
      width="495px"
    >
      <div class="dialog_box">
        <div class="logo"><img src="../assets/login_logo.png" /></div>
        <button style="margin-top: 50px" id="googleSignInBtn"></button>
        <ul>
          <li>
            <input
              class="user"
              v-model="loginForm.email"
              type="text"
              placeholder="请输入账户号码"
            />
          </li>
          <li>
            <input
              class="pwd"
              v-model="loginForm.password"
              type="text"
              placeholder="请输入账户密码"
            />
          </li>

          <li @click="login">
            <a href="javascript:;" class="btn">登录</a>
          </li>
          <li class="tip">
            <p>
              没有账号？<a
                href="javascript:;"
                class="link"
                @click="showReg = true"
                >去注册</a
              >
            </p>
          </li>
        </ul>
      </div>
    </el-dialog> -->
    <!-- 注册弹窗 - 已注释 -->
    <!-- <el-dialog
      title="注册"
      :visible.sync="showReg"
      :center="true"
      :show-close="false"
      width="495px"
    >
      <div class="dialog_box">
        <div class="logo"><img src="../assets/login_logo.png" /></div>
        <ul>
          <li>
            <input
              class="email"
              v-model="registerForm.email"
              type="email"
              placeholder="请输入邮箱地址"
            />
          </li>
          <li>
            <input
              class="code"
              type="text"
              v-model="registerForm.code"
              placeholder="请输入验证码"
            />
            <template>
              <span class="get" @click="send" v-if="time == 60"
                >获取验证码</span
              >
              <span class="time" v-else>已发送（{{ time }}）</span>
            </template>
          </li>
          <li>
            <input
              class="pwd"
              type="text"
              v-model="registerForm.password"
              placeholder="请设置密码"
            />
          </li>
          <li>
            <input
              class="pwd"
              type="text"
              v-model="password"
              placeholder="请确认密码"
            />
          </li>
          <li>
            <input
              class="email"
              v-model="registerForm.inviteCode"
              type="text"
              placeholder="请输入邀请码"
            />
          </li>
          <li @click="register">
            <a href="javascript:;" class="btn">注册</a>
          </li>
          <li class="tip">
            <p>
              已有账号？<a
                href="javascript:;"
                class="link"
                @click="$store.state.showLogin = true"
                >返回登录</a
              >
            </p>
          </li>
        </ul>
      </div>
    </el-dialog> -->
    
    <!-- 设置密码弹窗 -->
    <SetPasswordModal
      :visible="$store.state.user.showSetPasswordModal"
      :email="$store.state.user.setPasswordModalEmail"
      @close="handlePasswordModalClose"
      @success="handlePasswordModalSuccess"
      @skip="handlePasswordModalSkip"
    />
  </div>
</template>

<script>
import {
  sendCode,
  register,
  loginByPassword,
} from "@/api/login.js";
import { getToken } from "@/utils/auth";
import { resolveLoginRedirectPath } from "@/utils/login";
import SetPasswordModal from "./SetPasswordModal.vue";
import ChangeLanguage from "./i18n/ChangeLanguage.vue";

export default {
  name: "NavCom",
  components: {
    SetPasswordModal,
    ChangeLanguage
  },
  data() {
    return {
      // showLogin: false,
      showReg: false,
      showLoginCard: false,
      registerForm: {
        email: "",
        password: "",
        code: "",
        inviteCode: "",
      },
      loginForm: { email: "", password: "" },
      password: "",
      time: 60,
      key: null,
      clientId:
        "375993861305-hmmdf624kqfbkfc1hp00v304694kl97b.apps.googleusercontent.com",
      googleSignInParams: {
        client_id:
          "375993861305-hmmdf624kqfbkfc1hp00v304694kl97b.apps.googleusercontent.com",
        scope: "profile email",
      }
    };
  },
  watch: {
    showLogin(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.initGoogleSignIn();
        });
        // this.initGoogleSignIn();
        this.showReg = false;
      }
    },
    showReg(newValue, oldValue) {
      if (newValue) {
        this.$store.state.showLogin = false;
      }
    },
  },
  computed: {
    showLogin() {
      return this.$store.state.showLogin;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isLoginPage() {
      return this.$route.name === 'Login';
    },
  },
  mounted() {
    

    // 监听全局点击事件
    this.$bus.$on("close-login-card", this.closeLoginCard);
  },
  beforeDestroy() {
    // 移除事件监听
    this.$bus.$off("close-login-card", this.closeLoginCard);
  },
  methods: {
    // async googleLogin() {
    //   const provider = new GoogleAuthProvider();
    //   try {
    //     const result = await signInWithPopup(getAuth(), provider);
    //     this.$emit("login-success", result.user);
    //   } catch (error) {
    //     console.error("登录失败:", error);
    //   }
    // },
    handleCommand(command) {
      if (!command) {
        return;
      }
      const targetPath = command === "__login__" ? "/login" : command;
      if (targetPath !== this.$route.path) {
        this.$router.push({ path: targetPath }).catch(() => {});
      }
    },
    async logout() {
      this.$confirm(this.$t('auth.confirmLogout'), this.$t('auth.confirmTitle'), {
        confirmButtonText: this.$t('auth.ok'),
        cancelButtonText: this.$t('auth.cancel'),
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("FedLogOut").then(() => {
            location.href = "/";
          });
        })
        .catch(() => {});
    },
    getToken,
    toggleLoginCard() {
      this.showLoginCard = !this.showLoginCard;
    },
    closeLoginCard() {
      this.showLoginCard = false;
    },
    openLogin() {
      if (this.getToken()) {
        return;
      } else {
        this.$store.state.showLogin = true;
      }
    },
    async login() {
      try {
        if (!this.validateEmail(this.loginForm.email)) {
          this.$message.error(this.$t('auth.invalidEmail'));
          return;
        }
        if (!this.loginForm.password) {
          this.$message.error(this.$t('auth.passwordRequired'));
          return;
        }
        const res = await loginByPassword({
          ...this.loginForm,
        });

        if (res.code == 200) {
          this.$store.state.showLogin = false;
          this.loginForm = {
            email: "",
            password: "",
          };
          await this.$store.dispatch("ApplyLoginSession", res.data);
          this.$message.success(this.$t('auth.loginSuccess'));
          if (this.$store.state.user.userInfo.hasPassword !== false) {
            await this.$router.push(this.getPostLoginRedirectPath());
          }
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$message.error(this.$t('auth.loginFailedRetry'));
      }
    },
    async send() {
      if (!this.validateEmail(this.registerForm.email)) {
        this.$message.error(this.$t('auth.invalidEmail'));
        return;
      }
      let res = await sendCode({
        type: 1,
        account: this.registerForm.email,
      });
      if (res.code == 200) {
        this.key = setInterval(() => {
          this.time--;
          if (this.time == 0) {
            this.time = 60;
            clearInterval(this.key);
            this.key = null;
          }
        }, 1000);
        // this.$message.success("发送成功");
      }
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    async register() {
      try {
        if (!this.validateEmail(this.registerForm.email)) {
          this.$message.error(this.$t('auth.invalidEmail'));
          return;
        }
        if (!this.registerForm.code) {
          this.loading = false;
          this.$message({
            showClose: true,
            message: this.$t('auth.codeRequired'),
            type: "error",
            duration: 0,
          });
          return false;
        }
        if (
          this.registerForm.password.length < 6 ||
          this.registerForm.password.length > 20
        ) {
          this.$message({
            showClose: true,
            message: this.$t('auth.passwordLength'),
            type: "error",
          });
          return false;
        }
        if (this.registerForm.password != this.password) {
          this.$message({
            showClose: true,
            message: this.$t('auth.passwordMismatch'),
            type: "error",
          });
          return false;
        }
        const res = await register({
          ...this.registerForm,
        });

        if (res.code == 200) {
          this.showReg = false;
          await this.$store.dispatch("ApplyLoginSession", res.data);
          this.$message.success(this.$t('auth.registerLoginSuccess'));
          if (this.$store.state.user.userInfo.hasPassword !== false) {
            await this.$router.push(this.getPostLoginRedirectPath());
          }

          this.registerForm = {
            email: "",
            password: "",
            code: "",
            inviteCode: "",
          };
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$message.error(this.$t('auth.loginFailedRetry'));
      }
    },
    getPostLoginRedirectPath() {
      return resolveLoginRedirectPath(this.$route.query.redirect, "/");
    },
    handlePasswordModalClose() {
      this.$store.dispatch("hideSetPasswordModal");
      this.$router.push(this.getPostLoginRedirectPath());
    },
    handlePasswordModalSuccess() {
      this.$store.dispatch("hideSetPasswordModal");
      this.$router.push(this.getPostLoginRedirectPath());
    },
    handlePasswordModalSkip() {
      this.$store.dispatch("hideSetPasswordModal");
      this.$router.push(this.getPostLoginRedirectPath());
    },
  },
};
</script>

<style lang="scss" scoped>
#googleSignInBtn {
  display: block;
  margin: 0 auto;
}
#nav {
  // padding-top: 35px;
  .logo {
    a {
      img {
        height: 46px;
      }
    }
  }
  .menu {
    ul {
      overflow: visible; // 改为 visible，让登录卡片可以显示
      li {
        float: left;
        margin: 0 15px;
        &.active {
         // background: #1d3fff;
         border-bottom: 2px solid #409EFF;
        // border-bottom-color: ;
        //  border-radius: 23px 23px 23px 23px;
          a {
            color: white;
          }
        }
        &.user {
          .user_dropdown{
            vertical-align: middle;
          }
          .user-container {
            position: relative;
            a {
              padding: 0;
              img {
                width: 46px;
                font-size: 0;
                display: block;
                border-radius: 50%;
              }
            }
          }
          a {
            padding: 0;
            img {
              width: 46px;
              font-size: 0;
              display: block;
              border-radius: 50%;
            }
          }
        }
        a {
          padding: 9px 25px;
          display: block;
          font-size: 18px;
          font-weight: bold;
          color: #DEE1E6;
          transition: color 0.3s ease;
          
          &:hover {
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
.switch_lang{
  width: 150px;
  left: -150px;
  background-color: white;
  position: absolute;
  margin-top: -36px;
  display: none;
  box-shadow: 0 5px 6px -3px #0003, 0 9px 12px 1px #00000024, 0 3px 16px 2px #0000001f;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
}
.el-dropdown-menu {
  width: 160px;
  .el-dropdown-menu__item {
    margin: 8px 0;
    &:last-child:hover {
      background-color: white;
    }
    &:hover{
      .switch_lang{
        display: block;
      }
    }
  }
  .u_user {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_user.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_sub {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_sub.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_tg {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_tg.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_qs {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_qs.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_od {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_od.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_wallet {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_tg.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_coupon {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/coupon.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_lang {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_lang.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .logout {
    display: block;
    width: 90px;
    text-align: center;
    margin: 0 auto;
    background: #eaeaea;
    border-radius: 17px 17px 17px 17px;
    height: 34px;
    line-height: 34px;
  }
}
::v-deep .el-dialog--center .el-dialog__body {
  padding: 50px;
  padding-top: 0px;
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog {
  background: #ffffff url(../assets/bg_login.png) no-repeat top left;
  background-size: 100% auto;
  border-radius: 25px;
}
.dialog_box {
  font-size: 15px;
  line-height: 68px;
  color: #333333;
  .logo {
    text-align: center;
    padding-top: 40px;
    position: relative;
    img {
      width: 126px;
    }
    &::after {
      display: inline-block;
      content: " ";
      height: 4px;
      width: 43px;
      height: 4px;
      background: #080808;
      border-radius: 2px 2px 2px 2px;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -21px;
    }
  }
  ul {
    li {
      display: flex;
      align-items: center;
      margin-top: 35px;
      &.tit {
        line-height: 1;
        margin-bottom: -10px;
      }
      &.tip {
        display: block;
        line-height: 1;
        p {
          text-align: center;
          line-height: 1;
          a {
            color: rgba(29, 63, 255, 1);
          }
        }
      }
      p {
        font-size: 15px;
        color: #333333;
        line-height: 68px;
      }
      textarea {
        background: #f4f4f4;
        border-radius: 16px 16px 16px 16px;
        height: 94px;
        border: 0;
        width: 100%;
        padding: 20px;
      }
      input {
        height: 42px;
        line-height: 42px;
        flex: 1;
        background-color: #f3f3f3;
        border-radius: 21px 21px 21px 21px;
        border: 0;
        padding-left: 20px;
        &.code {
          background: #f3f3f3 url(../assets/icon_code.png) no-repeat 20px center;
          background-size: auto 35%;
          padding-left: 50px;
        }
        &.user {
          background: #f3f3f3 url(../assets/login_user.png) no-repeat 20px
            center;
          background-size: auto 35%;
          padding-left: 50px;
        }
        &.pwd {
          background: #f3f3f3 url(../assets/icon_pwd.png) no-repeat 20px center;
          background-size: auto 35%;
          padding-left: 50px;
        }
        &.email {
          background: #f3f3f3 url(../assets/icon_email.png) no-repeat 20px
            center;
          background-size: auto 25%;
          padding-left: 50px;
        }
      }
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-input__inner {
        background-color: #f4f4f4;
        border-color: #f4f4f4;
        border-radius: 50px;
      }
      span {
        height: 42px;
        line-height: 42px;
        width: 121px;
        background: #a5a5a5;
        border-radius: 21px 21px 21px 21px;
        text-align: center;
        color: white;
        margin-left: 10px;
        cursor: not-allowed;
        &.get {
          background: #1d3fff;
          color: white;
          cursor: pointer;
        }
      }
      .btn {
        width: 100%;
        height: 43px;
        line-height: 43px;
        text-align: center;
        color: white;
        background: linear-gradient(135deg, #1d40ff 0%, #4a6aff 100%);
        border-radius: 22px 22px 22px 22px;
        display: block;
        margin: 0 auto;
        transition: all 0.3s;
        &:hover {
          background: linear-gradient(135deg, #1530cc 0%, #1d40ff 100%);
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(29, 64, 255, 0.3);
        }
      }
    }
  }
}

.google-login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.google-login-btn:hover {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.google-login-btn img {
  width: 20px;
  margin-right: 10px;
}

.login-btn {
  width: 100%;
  height: 35px;
  background: #1d3fff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    background: #1d3fff;
    transform: translateY(0);
  }
}

// 添加箭头指向个人图标
.login-card::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
}

.login-card::after {
  content: "";
  position: absolute;
  top: -9px;
  right: 19px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid #f0f0f0;
}

// 登录页面导航栏特殊样式
#nav.nav-login-page {
  .menu ul li {
    a {
      color: #DEE1E6 !important;
      
      &:hover {
        color: #FFFFFF !important;
      }
    }
    
    &.active a {
      color: #FFFFFF !important;
    }
  }
}
</style>
